import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MatDialog } from "@angular/material/dialog";
import { ContactService } from "../../services/contact.service";
import { IContact } from "../../models/contact";
import { Router } from "@angular/router";

import { ContactSuccessComponent } from "./contactsuccess.component";
import { ContactFailedComponent } from "./contactfailed.component";

@Component({
  selector: "app-contactform",
  templateUrl: "./contactform.component.html",
  styleUrls: ["./contactform.component.css"],
})
export class ContactFormComponent implements OnInit {
  name = new FormControl("", [Validators.required]);

  email = new FormControl("", [Validators.required, Validators.email]);

  subject = new FormControl("", [Validators.required]);

  message = new FormControl("", [Validators.required]);

  sendForm: FormGroup = new FormGroup({
    name: this.name,
    email: this.email,
    subject: this.subject,
    message: this.message,
  });

  constructor(
    private contactService: ContactService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit() {}

  isLoading: boolean = false;

  send() {
    this.isLoading = true;

    const contactInfo = {
      name: this.name.value,
      email: this.email.value,
      subject: this.subject.value,
      message: this.message.value,
    };

    if (!this.sendForm.valid) {
      this.isLoading = false;
      return;
    }

    this.contactService.send(contactInfo).subscribe((res) => {
      this.dialog.open(ContactSuccessComponent, {});
    });
  }
}
